import { useLocation } from 'react-router-dom'
import { MessageCircle } from 'lucide-react'

// Floating WhatsApp chat button for the public marketing pages.
const WHATSAPP_NUMBER = '256706739311'
const MESSAGE = "Hi SMA, I'd like to know more about your programs."

const PUBLIC_PREFIXES = [
  '/programs',
  '/intake',
  '/showcase',
  '/gallery',
  '/masterclass',
  '/project-lab',
  '/creative-tools',
  '/holiday-programs',
  '/contact',
  '/advisor',
]

export default function WhatsAppButton() {
  const { pathname } = useLocation()
  const isPublic =
    pathname === '/' ||
    PUBLIC_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
  if (!isPublic || pathname.startsWith('/masterclass/admin')) return null

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MESSAGE)}`

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with SMA on WhatsApp"
      title="Chat on WhatsApp"
      className={`fixed ${pathname === '/masterclass' ? 'bottom-28 sm:bottom-5' : 'bottom-5'} right-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#25D366] p-3.5 text-white font-sans text-sm font-semibold shadow-lg shadow-black/40 transition hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white`}
    >
      <MessageCircle className="w-6 h-6" aria-hidden="true" />
    </a>
  )
}
